import * as React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import AdvancedSearch from './AdvancedSearch';
import { useHistory } from 'react-router-dom';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const AdvancedSearchPopup = ({ isOpened }: any) => {
    const history = useHistory();

    return (
        <>
            <div>
                <Dialog
                    sx={{ "& .MuiDialog-paper": { backgroundColor: "#f5f4f9" } }}
                    fullScreen
                    TransitionComponent={Transition}
                    open={isOpened}
                    disableEscapeKeyDown={true}
                    onClose={history.goBack}

                >
                    <div className='advanced-container' style={{ overflowY: "auto" }}>
                        <AdvancedSearch />
                    </div>
                </Dialog>
            </div>
        </>


    )
}


export default AdvancedSearchPopup;